import { render, staticRenderFns } from "./roles.vue?vue&type=template&id=2790c4f7&"
import script from "./roles.vue?vue&type=script&lang=js&"
export * from "./roles.vue?vue&type=script&lang=js&"
import style0 from "./roles.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./roles.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports